import { Link } from "react-router-dom";
import { SocialMediaAccountWidgetStyled } from "./styled";
import { Icons } from "components";

const SocialMediaAccountWidget = () => {
  return (
    <SocialMediaAccountWidgetStyled>
      <div className="social_media_account_list">
        <Link
          className="youtube"
          to="https://www.youtube.com/@YamahaMusicThailandOfficial"
          target="_blank"
        >
          <Icons.Youtube />
        </Link>
        <Link
          className="social_item"
          to="https://www.facebook.com/yamahamusicthailand"
          target="_blank"
        >
          <Icons.Facebook />
        </Link>
        <Link
          className="social_item"
          target="_blank"
          to="https://www.instagram.com/yamahamusicthailand"
        >
          <Icons.Instagram />
        </Link>
        <Link
          className="social_item"
          target="_blank"
          to="https://www.tiktok.com/@yamahamusicthailand"
        >
          <Icons.Tiktok />
        </Link>
      </div>
    </SocialMediaAccountWidgetStyled>
  );
};

export default SocialMediaAccountWidget;
